module.exports = __webpack_public_path__ + "static/media/thumbsup.fa455750.svg";